import { AsyncPipe } from '@angular/common';
import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectionType } from '@siemens/ngx-datatable';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { DatatableColumn, RktTableComponent } from '@rocketfinancialcorp/rocket-ui/table';

import { FundOnHold } from '@shared/models';
import { transactionFormFeature } from '@shared/store';

@Component({
  selector: 'app-foh-selection-modal',
  templateUrl: './foh-selection-modal.component.html',
  imports: [RktButtonDirective, AsyncPipe, RktTableComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class FohSelectionModalComponent implements AfterViewChecked {
  fundsOnHold$ = this.store.select(transactionFormFeature.selectFundsOnHoldItems);
  isLoading$ = this.store.select(transactionFormFeature.selectFundsOnHoldLoading);

  selectedFoh: FundOnHold[] = [];

  selectionType = SelectionType.single;

  columns: DatatableColumn[] = [
    { name: 'Amount', prop: 'amount', fixedSize: 120, colType: 'amount' },
    { name: 'Memo', prop: 'memo', flexSize: 3 },
    { name: 'Expiry', prop: 'expiry', fixedSize: 180, colType: 'date-time' },
    { name: 'Status', prop: 'status', fixedSize: 100, colType: 'status-tag' },
  ];

  constructor(
    public activeModal: ActiveModal,
    private ref: ChangeDetectorRef,
    private store: Store,
  ) {}

  ngAfterViewChecked(): void {
    this.ref.detectChanges();
  }

  modalInitData({ selectedFundOnHold }: { selectedFundOnHold?: FundOnHold | null }) {
    if (selectedFundOnHold) {
      this.selectedFoh = [selectedFundOnHold];
    }
  }

  onSelectBtnClick() {
    this.activeModal.close(this.selectedFoh[0] || null);
  }

  onFohSelect(data: unknown): void {
    const { selected = [] } = data as { selected?: FundOnHold[] };
    this.selectedFoh = [...selected];
  }
}
